<template>
  <card-list
    title="Customer List"
    data-size="10"
    data-url="/api/v1/customer"
    edit-route="/master/customer/add"
    delete-endpoint="/api/v1/customer"
    :data-headers="tHeaders"
  />
</template>
<script>
import CardList from "../../components/CardList";
export default {
  name: "CustomerList",
  components: {
    CardList,
  },
  data () {
    return {
      tHeaders: [
        { customer_id: 'Customer ID', align: 'left' },
        { name: 'Name', align: 'left' },
        { type_name: 'Type', align: 'left' },
        { perusahaan: 'Perusahaan', align: 'left' },
        { address: 'Alamat', align: 'left' },
        { phone: 'Telepon', align: 'left' },
        { email: 'Telepon', align: 'left' },
      ]
    }
  }
}
</script>
